export default __webpack_public_path__ + "static/media/AWS1.22b1cfaa.png";